import { __assign } from "tslib";
export function keepSupportedCeTypes(content, supportedCeTypes) {
    var pages = content.pages;
    var contentItems = content.contentItems;
    var unsupportedSectionIds = new Set();
    if (supportedCeTypes) {
        pages = pages.map(function (page) { return (__assign(__assign({}, page), { sections: page.sections.filter(function (section) {
                var isCeTypeSupported = supportedCeTypes.has(section.ceType);
                if (!isCeTypeSupported) {
                    unsupportedSectionIds.add(section.id);
                }
                return isCeTypeSupported;
            }) })); });
        contentItems = contentItems.reduce(function (res, contentItem) {
            var _a, _b;
            if (!((_a = contentItem.sectionIds) === null || _a === void 0 ? void 0 : _a.length)) {
                // items used for default content
                res.push(contentItem);
            }
            else {
                var sectionIds = (_b = contentItem.sectionIds) === null || _b === void 0 ? void 0 : _b.filter(function (sectionId) { return !unsupportedSectionIds.has(sectionId); });
                if (sectionIds === null || sectionIds === void 0 ? void 0 : sectionIds.length) {
                    // items not used in any of supported CeTypes
                    res.push(__assign(__assign({}, contentItem), { sectionIds: sectionIds }));
                }
            }
            return res;
        }, []);
    }
    return __assign(__assign({}, content), { pages: pages,
        contentItems: contentItems });
}
//# sourceMappingURL=keepSupportedCeTypes.js.map